import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loading, setUsuarioLogin } from "../actions";

import { getTotalDashborad } from '../service/Dashboard';

export const Dashboard = () => {

    const [data, setData] = useState({});
    // Permisos
    const history = useHistory();
    const dispatch = useDispatch();

    const { usuario, colegio, anio } = useSelector((state) => ({
        usuario: state.usuario,
        colegio: state.colegio,
        anio: state.anio,
    }));

    //----------------------------
    const loadDataTotales = async () => {
        if (colegio.id !== undefined) {
            dispatch(loading(true));
            let dat = await getTotalDashborad(usuario.token, colegio.id, anio.anio);
            setData(dat.datos.matriculas);
            dispatch(loading(false));
        }
    };

    useEffect(() => {
        loadDataTotales();
    }, [anio]);

    return (
        <div className="p-grid dashboard p-pt-4">
            <div className="p-col-12 p-md-6 p-lg-3">
                <div className="p-grid overview-box overview-box-2">
                    <div className="overview-box-title">
                        <i className="pi pi-list"></i>
                        <span>MATRÍCULA TOTAL</span>
                    </div>
                    <div className="overview-box-count">{data.matriculas == null ? 0 : data.matriculas}</div>
                </div>
            </div>
            <div className="p-col-12 p-md-6 p-lg-3">
                <div className="p-grid overview-box overview-box-1">
                    <div className="overview-box-title">
                        <i className="pi pi-tag"></i>
                        <span>MATRÍCULA PIE</span>
                    </div>
                    <div className="overview-box-count">{data.matriculas_pie == null ? 0 : data.matriculas_pie}</div>
                </div>
            </div>
            <div className="p-col-12 p-md-6 p-lg-3">
                <div className="p-grid overview-box overview-box-3">
                    <div className="overview-box-title">
                        <i className="pi pi-users"></i>
                        <span>PRIORITARIOS</span>
                    </div>
                    <div className="overview-box-count">{data.prioritario == null ? 0 : data.prioritario}</div>
                </div>
            </div>
            <div className="p-col-12 p-md-6 p-lg-3">
                <div className="p-grid overview-box overview-box-4">
                    <div className="overview-box-title">
                        <i className="pi pi-users"></i>
                        <span>PREFERENTES</span>
                    </div>
                    <div className="overview-box-count">{data.preferente == null ? 0 : data.preferente}</div>
                </div>
            </div>
        </div>
    );
}
